module.exports = __webpack_public_path__ + "static/media/wheel-ayultai.b801b478.png";